import { ModernSelect } from "@components/Select";
import { ClientContext } from "@context/Client/ClientContext";
import StarIcon from "@mui/icons-material/Star";
import StarOutlineIcon from "@mui/icons-material/StarOutline";
import { Box, Grid, SelectChangeEvent } from "@mui/material";
import { useModelScenarios } from "@services/api";
import { useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";
import ScenarioSelectorsSkeleton from "./ScenarioSelectorsSkeleton";

export interface ScenarioSelectorsProps {
  selectedScenario1: string;
  selectedScenario2: string;
  handleChangeScenario1: (event: SelectChangeEvent) => void;
  handleChangeScenario2: (event: SelectChangeEvent) => void;
}

const ScenarioSelectors = ({
  selectedScenario1,
  selectedScenario2,
  handleChangeScenario1,
  handleChangeScenario2
}: ScenarioSelectorsProps) => {
  const { t } = useTranslation();
  const { currentClient } = useContext(ClientContext);

  const { data, isFetching: isLoading } = useModelScenarios(
    currentClient.model.id
  );

  const scenariosWithIcons = useMemo(() => {
    return (data || [])
      .sort((a, b) => (b.is_favorite ? 1 : -1))
      .map((scenario) => ({
        ...scenario,
        icon: scenario.is_favorite ? (
          <StarIcon sx={{ color: "#f5f107", mr: 1 }} />
        ) : (
          <StarOutlineIcon sx={{ mr: 1 }} />
        )
      }));
  }, [data]);

  return (
    <Box className="w-full flex space-x-4">
      {isLoading ? (
        <ScenarioSelectorsSkeleton
          key={`${currentClient.model.id}-benchmark-scenario-selectors-skeleton`}
        />
      ) : (
        <Grid container spacing={2} className="w-full">
          <Grid size={{ xs: 12, sm: 6, md: 6 }}>
            <Box sx={{ width: "100%" }}>
              <ModernSelect
                key="sc1-select"
                options={scenariosWithIcons}
                value={selectedScenario1}
                onChange={handleChangeScenario1}
                valueKey="id"
                labelKey="name"
                showIcons={true}
                colorTheme="light"
                label={t("simulator.benchmark.scenario_1")}
                labelId="sc1-select-select-label"
                id="sc1-select"
                autoWidth={true}
                minWidth={180}
              />
            </Box>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 6 }}>
            <Box sx={{ width: "100%" }}>
              <ModernSelect
                key="sc2-select"
                options={scenariosWithIcons}
                value={selectedScenario2}
                onChange={handleChangeScenario2}
                valueKey="id"
                labelKey="name"
                showIcons={true}
                colorTheme="light"
                label={t("simulator.benchmark.scenario_2")}
                labelId="sc2-select-select-label"
                id="sc2-select"
                autoWidth={true}
                minWidth={180}
              />
            </Box>
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

export default ScenarioSelectors;
